export const ACTUAL_ACTION_ITEMS = currentDeviceType => [
  {
    key: 'translationRequest',
    label: 'Запрос трансляции',
  },
  {
    key: 'trustUserGroup',
    label: 'Доступ к просмотру',
  },
  {
    key: 'clearLogin',
    label: 'Очистить пароль',
  },
  {
    key: 'deviceType',
    label: 'Тип устройства',
    children: [
      {
        key: 'tablet',
        label: 'Планшет',
        disabled: currentDeviceType === 'tablet',
      },
      {
        key: 'panel',
        label: 'Пульт',
        disabled: currentDeviceType === 'panel',
      },
      {
        key: 'router',
        label: 'Маршрутизатор',
        disabled: currentDeviceType === 'router',
      },
    ],
  },
  {
    key: 'blockUnblockDevice',
    label: 'Заблокировать',
  },
  {
    key: 'deleteDevice',
    label: 'Удалить',
  },
];

export const BLOCKED_ACTION_ITEMS = [
  {
    key: 'blockUnblockDevice',
    label: 'Разблокировать',
  },
  {
    key: 'deleteDevice',
    label: 'Удалить',
  },
];

export const DEVICES_TYPES = {
  ACTUAL: 'actual',
  ONLINE: 'online',
  BLOCK: 'block',
  DELETED: 'deleted',
};

export const DEVICES_TYPES_LIST = [
  {
    label: 'Актуальные',
    value: DEVICES_TYPES.ACTUAL,
  },
  {
    label: 'Онлайн',
    value: DEVICES_TYPES.ONLINE,
  },
  {
    label: 'Заблокированные',
    value: DEVICES_TYPES.BLOCK,
  },
  {
    label: 'Удаленные',
    value: DEVICES_TYPES.DELETED,
  },
];

export const ACTION_TYPES = {
  TRANSLATION_REQUEST: 'translationRequest',
  TRUST_USER_GROUP: 'trustUserGroup',
  CLEAR_LOGIN: 'clearLogin',
  ROUTER: 'router',
  PANEL: 'panel',
  TABLET: 'tablet',
  BLOCK_UNBLOCK_DEVICE: 'blockUnblockDevice',
  DELETE_DEVICE: 'deleteDevice',
};
